<template>
  <tbody>
    <tr>
      <th colspan="10">
        渠道审批信息
        <span class="add" v-if="details.bankExit == 2">
          反馈信息填写
        </span>
      </th>
    </tr>
    <tr>
      <td>审核人</td>
      <td>
        <el-input :value="feedbackInfoData.approvalName" :readonl="readonly" />
      </td>
      <td>反馈结果</td>
      <td>
        <common-select
          v-model="feedbackInfoData.statusResults"
          :list="manualReviewList"
          @input="getValue"
        />
      </td>
      <td>核准时间</td>
      <td>
        <el-input :value="feedbackInfoData.approveTime" readonly />
      </td>
      <td>申请额度</td>
      <td>
        <el-input :value="feedbackInfoData.applyLoanAmountquota" readonly />
      </td>
      <td>批复额度</td>
      <td>
        <el-input :value="feedbackInfoData.quota" readonly />
      </td>
    </tr>
    <tr>
      <td style="height: 100px">信息录入人</td>
      <td style="height: 100px; padding: 8px" colspan="9">
        <el-input
          v-model="feedbackInfoData.infoName"
          type="textarea"
          style="height: 100%"
          onkeyup="this.value=this.value.replace(/[^a-zA-Z0-9(\\x4e00-\\x9fa5)]/g,'');"
        />
      </td>
    </tr>
    <tr>
      <td style="height: 100px">审批意见</td>
      <td style="height: 100px; padding: 8px" colspan="9">
        <el-input
          v-model="feedbackInfoData.result"
          type="textarea"
          style="height: 100%"
        />
      </td>
    </tr>
    <slot></slot>
  </tbody>
</template>

<script>
export default {
  props: {
    value: Boolean,
    details: {
      type: Object,
      default() {
        return {}
      },
      comment: '经营者信息'
    },
    readonly: {
      type: Boolean,
      default: false,
      comment: '是否不能编辑内容'
    },
    setOpertionNum: Function
  },

  data() {
    return {
      corpSex: [
        { value: '1', label: '男' },
        { value: '2', label: '女' }
      ],
      education: [
        { value: 1, label: '博士及博士以上' },
        { value: 2, label: '硕士' },
        { value: 3, label: '本科' },
        { value: 4, label: '专科' },
        { value: 5, label: '高中' },
        { value: 6, label: '初中' },
        { value: 7, label: '小学' },
        { value: 8, label: '其他' }
      ],
      academic: [
        { value: 1, label: '学士' },
        { value: 2, label: '硕士' },
        { value: 3, label: '博士' },
        { value: 4, label: '其他' }
      ],
      marriage: [
        { value: 1, label: '未婚' },
        { value: 2, label: '已婚' },
        { value: 3, label: '离异' },
        { value: 4, label: '丧偶' },
        { value: 5, label: '其他' }
      ],
      residential: [
        { value: 1, label: '亲属房产' },
        { value: 2, label: '租用' },
        { value: 3, label: '自由' },
        { value: 4, label: '其他' }
      ],
      loanNo: [
        { value: 1, label: '是' },
        { value: 2, label: '否' }
      ]
    }
  },

  methods: {
    showAddressDialog(val) {
      this.$emit('setOpertionNum', val)
      this.$emit('input', true)
      // this.value = !this.value
    }
  }
}
</script>

<style lang="scss" scoped>
.range-input {
  max-width: 60px;
}

.editWord img {
  width: 16px;
  height: 16px;
}
</style>
